import React, { createContext, ReactNode, useContext, useState } from 'react';

interface PageMetadataContextType {
  description: string;
  actions: ReactNode;
}

// Create a context with default values
const PageMetadataContext = createContext<PageMetadataContextType>({
  description: '',
  actions: null,
});

// Create a ref to store the setter function
let setMetadataRef:
  | ((description: string, actions?: ReactNode) => void)
  | null = null;

// Export a static function to set metadata
export const setPageMetadata = (description: string, actions?: ReactNode) => {
  if (setMetadataRef) {
    setMetadataRef(description, actions);
  }
};

export const PageMetadataProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [metadata, setMetadata] = useState<PageMetadataContextType>({
    description: '',
    actions: null,
  });

  // Store the setter function in the ref
  setMetadataRef = (description: string, actions?: ReactNode) => {
    setMetadata({
      description,
      actions: actions ?? null,
    });
  };

  return (
    <PageMetadataContext.Provider value={metadata}>
      {children}
    </PageMetadataContext.Provider>
  );
};

export const usePageMetadata = () => useContext(PageMetadataContext);
